const LOCAL_STORAGE_AUTH_TOKEN = 'AUTH_TOKEN';
const LOCAL_STORAGE_USER_ID = 'USER_ID';
const LOCAL_STORAGE_USER_DATA = 'USER';
const LOCAL_STORAGE_USER_FORMSTACK = 'USER_FORMSTACK';
const LOCAL_STORAGE_USER_FORMSTACK_TOKEN = 'USER_FORMSTACK_TOKEN';

export {
  LOCAL_STORAGE_AUTH_TOKEN,
  LOCAL_STORAGE_USER_ID,
  LOCAL_STORAGE_USER_DATA,
  LOCAL_STORAGE_USER_FORMSTACK,
  LOCAL_STORAGE_USER_FORMSTACK_TOKEN,
};
